import React, { useState, useRef, useEffect } from "react";
import Spinner from "../spinners/spinner";
import { Stack } from "react-bootstrap";
import dropdownIcon from "../../assets/svgs/downArrow.svg";
import "./Multiselect.css";
import CheckboxRb from "../Buttons/checkbox/checkbox";
import SecondaryBtnRb from "../Buttons/secondaryBtnRb/secondaryBtnRb";
import searchIcon from '../../assets/icons/search-icon.png'
import { useDetectClickOutside } from 'react-detect-click-outside';
import { useGlobalContext } from "../../context/global";
import { Tooltip } from "react-tooltip";
import info from '../../assets/svgs/info.svg'
import { Box, CircularProgress } from "@mui/material";

const MultiSelect = ({ title, options,isShowSelectAll=true, defaultSelected, onApply,isSearch,placeHolder,classes,label,isLoading,hasFetched,optionChange,id,customSearch,renderItem,searchLogic , showInfo , infoText,externalDivClasses ,showLimitedOptions,limitedOptionsLimit,onSearchInput,onDropdownOpen }) => {
  const preFilteredOptions = options?.filter((option) => option !== undefined && option !== null && option !== "");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [optionsToShow,setOptionsToShow] = useState(preFilteredOptions ?? []) // If options undefined then put empty array []
  const [showOptions, setShowOptions] = useState(false);
  // Show the sorted options on the top.
  const [searchEnabled, setSearchEnabled] = useState(false)
  const sortedOptionsToShow = defaultSelectedSort(selectedOptions,optionsToShow)
  const [tempSelectedOptions, setTempSelectedOptions] = useState([]);
  // If limited options are to be shown then show the limited options otherwise show all the options.
  const selectedOptionsTemp = searchEnabled ? [] : tempSelectedOptions
  const sortedLimitedOptionsToShow = showLimitedOptions ? [...selectedOptionsTemp,...sortedOptionsToShow?.slice(0,limitedOptionsLimit)]?.filter((item,
    index,arr) => arr.indexOf(item) === index)?.slice(0,limitedOptionsLimit) : sortedOptionsToShow
  const isRemoteSearch = Boolean(onSearchInput);
  const showListLoader = isRemoteSearch && (isLoading || hasFetched === false);
  const showListEmpty =
    isRemoteSearch &&
    hasFetched &&
    !isLoading &&
    !sortedLimitedOptionsToShow?.length;
  const { dropdownBtnOptionsVisibilty, setDropdownBtnOptionsVisibilty } = useGlobalContext();

  // Effects 
  useEffect(()=> {
    setOptionsToShow(preFilteredOptions ?? [])
  },[options])
  // Adding this effect if the default selected options are changed from outside of this component then here selected options should also change.

  useEffect(() => {
    setSelectedOptions([...defaultSelected])
    setTempSelectedOptions([...defaultSelected])
  },[defaultSelected])

  useEffect(() => {
    if(optionChange && options) {
        setOptionsToShow(preFilteredOptions ?? [])
    }
  },[options])

  const resetRemoteSearch = () => {
    if (searchInputRef.current) {
      searchInputRef.current.value = "";
    }
    if (onSearchInput) {
      onSearchInput("");
    }
  };

  const closeDropdown = () => {
    setSelectedOptions(defaultSelected)
    setTempSelectedOptions(defaultSelected)
    setShowOptions(false);
    setOptionsToShow(preFilteredOptions ?? [])
    setSearchEnabled(false)
    resetRemoteSearch()
  };

  //Ref
  const ref = useDetectClickOutside({ onTriggered: closeDropdown});
  const searchInputRef = useRef(null);
  useEffect(() => {
		if(!dropdownBtnOptionsVisibilty){
			closeDropdown()
			setDropdownBtnOptionsVisibilty(true);
		}
	}, [dropdownBtnOptionsVisibilty]);

  // Methods
  const handleOptionChange = (event) => {
    event?.stopPropagation();
    const value = event.target.value;
    setTempSelectedOptions((prevSelectedOptions) => 
      prevSelectedOptions.includes(value) 
        ? prevSelectedOptions.filter((option) => option !== value) 
        : [...prevSelectedOptions, value]
    );
  };

  const handleApply = () => {
    setSelectedOptions(tempSelectedOptions);
    onApply(tempSelectedOptions);
    setShowOptions(false);
    setOptionsToShow(preFilteredOptions ?? []);
    setSearchEnabled(false)
    resetRemoteSearch()
  };

  const handleSelectAllChange = (event) => {
    if (event.target.checked) {
      setTempSelectedOptions(sortedOptionsToShow);
    } else {
      setTempSelectedOptions([]);
    }
  };

  const onCancelBtnhandler = () => {
    setSelectedOptions(defaultSelected);
    setTempSelectedOptions(defaultSelected)
    setShowOptions(false);
    setOptionsToShow(preFilteredOptions ?? []);
  };

  const onSearch = (e) => {
    const value = e.target.value;
    if (value === "") {
      setSearchEnabled(false)
    } else {
      setSearchEnabled(true)
    }

    if (onSearchInput) {
      onSearchInput(value);
      return;
    }

    const lowerValue = value.toLowerCase();
    const filteredOptions = options?.filter((option) => {
     return customSearch ? searchLogic(option, lowerValue) : option?.toLowerCase().includes(lowerValue)
    })
    setOptionsToShow([...filteredOptions])  
  }

  function defaultSelectedSort (defaultArray,optionsArray) {
    let newArray = []
    if(!searchEnabled) {
      newArray = defaultArray?.concat(optionsArray)
    } else {
      newArray = optionsArray
    }
    const sortedArray = new Set([...newArray])
    return Array.from(sortedArray)
  }
  

  return (
    <div ref={ref} key={title} className={`multiselect-external-div ${externalDivClasses ? externalDivClasses : ""}`}>
      <Stack className="d-flex flex-col w-100 position-relative cursor-pointer-global">
        {title ? (
          <>
          <div className="d-flex align-items-center gap-2">
            <label className="filter-options d-hide" htmlFor="campaign-type">
              {title}
            </label>
            {showInfo && 
            <span data-tooltip-content={infoText} data-tooltip-id="main-tooltip">
              <img className="info-icon info-icon-multiselect" src={info} alt="*" />
            </span> }
            <Tooltip id="main-tooltip"/>
          </div>

          </>
        ) : (
          ""
        )}
        <div
          className="select-button-container select-div w-100"
          onClick={() => {
            setShowOptions((prevShowOptions) => {
              const nextShowOptions = !prevShowOptions;
              if (nextShowOptions) {
                if (onSearchInput) {
                  onSearchInput("");
                }
                if (onDropdownOpen) {
                  onDropdownOpen();
                }
              }
              return nextShowOptions;
            });
          }}
        >
          <div
            id="campaign-type"
            className="selected-opt-show-btn "
            value={title}
          >
            {tempSelectedOptions.length > 0 ? <>Selected</>: <>Select</>}
            {tempSelectedOptions.length > 0 ?
            <div className="count-of-selcted-in-main-button-container mx-1">
              {tempSelectedOptions.length}
            </div>
            : <div className="count-of-selcted-in-main-button-container zero mx-2">0</div>}
          </div>
          {isLoading && !isRemoteSearch && <div className="for-loader mt-2"><Spinner size={"sm"} shape={"border"}/></div> }
          <div className="">
            <img className="dropdown-img-select" src={dropdownIcon} alt={"open-dropdown-icon"}/>
          </div>
        </div>
        {showOptions && (
          <div className={`select-option-container multiselect-option-wrapper ${classes && classes} ${label ? 'withLabel' : ''}`} >
           {isSearch &&  
            (<div className={"search-box-infind-box dynamic-width-search-bar w-100 position-static"}>
            <div>
              <img src={searchIcon} alt="searchIcon"></img>
            </div>
            <div className="finnd-input-text">
              <input
                ref={searchInputRef}
                type="text"
                placeholder={
                placeHolder
                }
                id={title}
                onChange={onSearch}
              ></input>
            </div>
          </div>)
        }
            <div
              className={`options-contaoner-cd lsit-table-scrollbar multiselect${
                showListLoader ? " is-loading" : ""
              }${showListEmpty ? " is-empty" : ""}`}
            >
            {showListLoader ? (
              <Box className="multiselect-remote-loading-state">
                <CircularProgress size={32} sx={{ color: "#4D4184" }} />
              </Box>
            ) : showListEmpty ? (
              <Box className="multiselect-remote-empty-state">No data found</Box>
            ) : (
              <>
            {isShowSelectAll && (
              <div className="select-opt">
                <CheckboxRb
                  multiselect
                  id={title}
                  name={title}
                  label="Select All"
                  classes="multiselect"
                  onChange={handleSelectAllChange}
                  checked={
                    sortedOptionsToShow.length > 0 &&
                    tempSelectedOptions.length === sortedOptionsToShow.length
                  }
                />
              </div>
            )}
              {sortedLimitedOptionsToShow?.map((option) => (
                <div key={option} className="select-opt">
                  <CheckboxRb
                    multiselect
                    id={option}
                    name={title}
                    value={option}
                    title={option}
                    label={renderItem ? renderItem(option) : option}
                    classes="multiselect"
                    onChange={handleOptionChange}
                    checked={tempSelectedOptions.includes(option)}
                  />
                </div>
              ))}
              </>
            )}
            </div>
            <div className="custom-drop-down-saerch-box-footer multiselect-footer">
              <SecondaryBtnRb
                secondaryBtnText="Cancel"
                className="primary-inactive-btn custom-drop-down-footer-btn"
                onClick={onCancelBtnhandler}
              ></SecondaryBtnRb>
              <SecondaryBtnRb
                secondaryBtnText="Apply"
                id={id ? id + '-apply-filter' : `apply-${title}-filter`}
                className="primary-active-btn custom-drop-down-footer-btn"
                onClick={handleApply}
              ></SecondaryBtnRb>
            </div>
          </div>
        )}
      </Stack>
    </div>
  );
};

export default MultiSelect;